import { render } from "./SearchForLargeScreen.vue?vue&type=template&id=fd6f0494&ts=true"
import script from "./SearchForLargeScreen.vue?vue&type=script&lang=ts"
export * from "./SearchForLargeScreen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__